module.exports = __webpack_public_path__ + "static/level2-43c06b1a8d722b2b58097dda3f6122e5.png";